import { render, staticRenderFns } from "./Area.vue?vue&type=template&id=4825588a&"
import script from "./Area.vue?vue&type=script&lang=ts&"
export * from "./Area.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports